/**
 * 页面间跳转的小链接（菜单重组 §八 第二轮）：页名默认取 plan-tabs.ts，改名不用逐处改。
 * 用在说明文字或字段旁（不加横幅、不加按钮）。每条跳转都登记在页面注册表 page-registry.json 的 jumps，
 * 核查脚本按 `<PageJump to="…">` 认出它（apps/admin/scripts/plan-registry-audit.mjs R7）。
 */
import { Link } from "@tanstack/react-router";
import type * as React from "react";

import { PLAN_TABS, type PlanTab } from "../shell/plan-tabs";

export function PageJump({ to, children }: { to: PlanTab; children?: React.ReactNode }) {
	return (
		<Link
			to="/plan-lab"
			hash={to}
			className="text-brand-accent hover:underline"
			data-testid={`plan-jump-${to}`}
		>
			{children ?? `「${PLAN_TABS[to].title}」`}
		</Link>
	);
}
